<template>
    <div id="sidebar" :class="{ collapsed: isCollapsed }">
        <div class="end-user-category">
            <router-link v-if="UserCanAccessWorkflow" :to="{ name: `${getDefaultWorkflowRoute()}` }" :title="Localizer.Localize('Sidebar_Workflow')">
                <div class="sidebar-button">
                    <img src="../../public/icons/processV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Workflow") }}</span>
                </div>
            </router-link>
            <router-link
                v-if="UserCanAccessJournals && FeatureFlagJournals"
                :to="{ name: `${getDefaultJournalEntriesRoute()}` }"
                :title="Localizer.Localize('Sidebar_Journals')"
            >
                <div class="sidebar-button">
                    <img src="../../public/icons/journalsV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Journals") }}</span>
                </div>
            </router-link>
            <router-link :to="{ name: RouteNames.ExplorerRoute }" :title="Localizer.Localize('Sidebar_Explore')">
                <div class="sidebar-button">
                    <img src="../../public/icons/explorerV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Explore") }}</span>
                    <span
                        v-if="Tabs.length > 0"
                        class="counter"
                        @click.prevent.stop="setShowWindowsContextMenu($event)"
                    >
                        {{ Tabs.length }}
                    </span>
                </div>
            </router-link>
            <router-link v-if="FeatureFlagMatching && UserCanAccessMatching" :to="{ name: `${RouteNames.MatchingUI}` }" :title="Localizer.Localize('Sidebar_Matching')">
                <div class="sidebar-button">
                    <img src="../../public/icons/matching/matchingV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Matching") }}</span>
                </div>
            </router-link>
        </div>
        <div class="configuration-category">
            <router-link v-if="UserCanAccessModels" :to="{ name: String(modelsRoute) }" :title="Localizer.Localize('Sidebar_Models')">
                <div class="sidebar-button">
                    <img src="../../public/icons/metadataV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Models") }}</span>
                </div>
            </router-link>
            <router-link v-if="UserCanAccessMaintenance" :to="{ name: `${getDefaultMaintenanceRoute()}` }" :title="Localizer.Localize('Sidebar_Maintenance')">
                <div class="sidebar-button">
                    <img src="../../public/icons/maintenanceV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Maintenance") }}</span>
                </div>
            </router-link>
            <router-link v-if="UserCanAccessConfiure" :to="{ name: String(configureRoute) }" :title="Localizer.Localize('Sidebar_Configuration')">
                <div class="sidebar-button">
                    <img src="../../public/icons/dataV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Configuration") }}</span>
                </div>
            </router-link>
            <router-link v-if="UserCanAccessSecurity" :to="{ name: String(securityRoute) }" :title="Localizer.Localize('Sidebar_Security')">
                <div class="sidebar-button">
                    <img src="../../public/icons/usersV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Security") }}</span>
                </div>
            </router-link>
        </div>
        <div class="system-category">
            <router-link v-if="UserCanAccessAudit && FeatureFlagAuditModule" :to="{ name: `${RouteNames.AuditRoute}` }" :title="Localizer.Localize('Sidebar_Audit')">
                <div class="sidebar-button">
                    <img src="../../public/icons/logV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Audit") }}</span>
                </div>
            </router-link>
            <router-link v-if="UserCanAccessLogs" :to="{ name: String(logsRoute) }" :title="Localizer.Localize('Sidebar_Logs')">
                <div class="sidebar-button">
                    <img src="../../public/icons/logV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_Logs") }}</span>
                </div>
            </router-link>
            <router-link v-if="UserCanAccessAbout != null" :to="{ name: String(aboutRoute) }" :title="Localizer.Localize('Sidebar_About')">
                <div class="sidebar-button">
                    <img src="../../public/icons/infoV2.svg" class="size-sm" />
                    <span v-if="!isCollapsed">{{ Localizer.Localize("Sidebar_About") }}</span>
                </div>
            </router-link>
        </div>
        <router-link
            v-for="(item, i) in HomeExtensions"
            :to="{ name: RouteNames.HomeExtensionRoute, params: { id: item.id } }"
            :title="item.caption"
        >
            <div class="sidebar-button">
                <img :src="item.svg" class="size-sm" />
                <span v-if="!isCollapsed">{{ item.caption }}</span>
            </div>
        </router-link>
        <!-- Collapse/Expand Button at Footer -->
        <div class="sidebar-footer">
            <div class="collapse-button" @click="toggleCollapse" :title="isCollapsed ? 'Expand' : 'Collapse'">
                <template v-if="isCollapsed">
                    <img src="../../public/icons/double_right_arrow.svg" class="collapse-icon" alt="Expand" />
                </template>
                <template v-else>
                    <img src="../../public/icons/double_left_arrow.svg" class="collapse-icon" alt="Collapse" />
                </template>
            </div>
        </div>
        <ContextMenu
            v-if="ShowWindowsContextMenu"
            :TriggerEvent="ShowWindowsContextMenu"
            @close="ShowWindowsContextMenu = null"
        >
            <template #buttons>
                <div v-for="tab in Tabs" class="context_menu_btn" :Key="tab.Key" @click="Open(tab)">
                    <img class="theme-svg" src="../../public/icons/explorer/context_menu/open.svg" />
                    &nbsp;{{ tab.Name }}
                </div>
            </template>
        </ContextMenu>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import { Localizer } from "@/api/Localizer";
import RouteNames from "../routing/RouteNames";
import * as api from "../api/ApiClient";
import ContextMenu from "./helpers/ContextMenu.vue";
import { WindowsTabData, ChatWindowsTabData } from "@/api/WindowsTabData";
import { RouteRecordName } from "vue-router";
import { AuthClient } from "../api/ApiClientBase";
import { isFeatureFlagEnabled } from "@/services/featureFlagService";

@Component({ components: { ContextMenu } })
export default class Sidebar extends Vue {
    public RouteNames = RouteNames;
    private Localizer = new Localizer(this.$store);
    private isCollapsed: boolean = false;

    // Data property to store the async result
    private auditModuleFlagEnabled: boolean = false;

    private configureRoute: string | RouteRecordName | null | undefined = this.getDefaultConfigureRoute;
    private logsRoute: string | RouteRecordName | null | undefined = this.getDefaultLogsRoute;
    private securityRoute: string | RouteRecordName | null | undefined = this.getDefaultSecurityRoute;
    private modelsRoute: string | RouteRecordName | null | undefined = this.getDefaultModelsRoute;
    private aboutRoute: string | RouteRecordName | null | undefined = this.getDefaultAboutRoute;
    private extensions: api.HomeExtension[] = [];

    @Watch("$route") onRouteChange() {
        if (this.$route.fullPath.startsWith("/data")) {
            this.configureRoute = this.$route.name;
        } else {
            this.configureRoute = this.getDefaultConfigureRoute;
        }

        if (this.$route.fullPath.startsWith("/metadata")) {
            this.modelsRoute = this.$route.name;
        } else {
            this.modelsRoute = this.getDefaultModelsRoute;
        }

        if (this.$route.fullPath.startsWith("/security")) {
            this.securityRoute = this.$route.name;
        } else {
            this.securityRoute = this.getDefaultSecurityRoute;
        }

        if (this.$route.fullPath.startsWith("/logs")) {
            this.logsRoute = this.$route.name;
        } else {
            this.logsRoute = this.getDefaultLogsRoute;
        }

        if (this.$route.fullPath.startsWith("/about")) {
            this.aboutRoute = this.$route.name;
        } else {
            this.aboutRoute = this.getDefaultAboutRoute;
        }
    }

    @Watch("ModuleSecurityAccess") async onModuleSecurityAccessLoad() {
        this.configureRoute = this.getDefaultConfigureRoute;
        this.logsRoute = this.getDefaultLogsRoute;
        this.securityRoute = this.getDefaultSecurityRoute;
        this.modelsRoute = this.getDefaultModelsRoute;

        var auth_client = AuthClient.getInstance();
        await auth_client.ensureToken();
        var client = new api.ExtensionClient(auth_client);
        this.extensions = await client.homeExtensions();

        // Check feature flags when security access changes
        await this.checkAuditModuleFeatureFlag();
    }

    get Tabs(): WindowsTabData[] {
        return this.$store.state.windowstabs.Tabs;
    }

    get FeatureFlagJournals(): boolean {
        const ud = this.$store.state.security.UserData as api.ExtendedUserData;
        if (ud != null && ud.featureFlags != null) {
            for (let i = 0; i < ud.featureFlags!.length; i++) {
                if (ud.featureFlags[i] == "Journals") {
                    return true;
                }
            }
        }
        return false;
    }

    get FeatureFlagMatching(): boolean {
        const ud = this.$store.state.security.UserData as api.ExtendedUserData;
        if (ud != null && ud.featureFlags != null) {
            for (let i = 0; i < ud.featureFlags!.length; i++) {
                if (ud.featureFlags[i] == "MatchingUI") {
                    return true;
                }
            }
        }
        return false;
    }

    get FeatureFlagAuditModule(): boolean {
        return this.auditModuleFlagEnabled;
    }

    async checkAuditModuleFeatureFlag(): Promise<void> {
        try {
            this.auditModuleFlagEnabled = await isFeatureFlagEnabled("AuditModule");
        } catch (error) {
            console.error("Error checking AuditModule feature flag:", error);
            this.auditModuleFlagEnabled = false;
        }
    }

    async mounted() {
        // Check feature flags on component mount
        await this.checkAuditModuleFeatureFlag();
    }

    get HomeExtensions(): any[] {
        return this.extensions;
    }

    get CurrentUser(): api.UserData | null {
        return this.$store?.state.security.UserData;
    }

    get ModuleSecurityAccess(): api.Module[] | null {
        return this.$store?.state.security.ModuleSecurity;
    }

    ModuleIdInAccess(id: any): boolean {
        if (this.ModuleSecurityAccess != null) {
            var moduleAccess = this.ModuleSecurityAccess.filter((m) => m.id == id);
            if (moduleAccess.length > 0) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    get UserCanAccessWorkflow(): boolean {
        return true;
    }

    get UserCanAccessModels(): boolean {
        return (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelManagementManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelViewsManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsView) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsDelete) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsCreateUpdate))
        );
    }

    get UserCanAccessSecurity(): boolean {
        return (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementCreate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementUpdate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementDelete) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementCreate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementUpdate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementDelete) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementAssignAuthorization) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityFileSystemSecurityAssign) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementUserReports))
        );
    }

    get UserCanAccessConfiure(): boolean {
        return (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.ConfigurationDataSourcesConnectionsManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.ConfigurationStagingTablesManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.DataImportsDataImportDefinitionsManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.DataImportsMappingsView) ||
                this.ModuleIdInAccess(api.ModuleAccess.DataImportsMappingsManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.HomepagesHomepageManagementManage) ||
                this.ModuleIdInAccess(api.ModuleAccess.ConfigurationJournalEntriesManageSettings) ||
                this.ModuleIdInAccess(api.ModuleAccess.ThemeCustomSettingsManage))
        );
    }

    get UserCanAccessJournals(): boolean {
        return this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.JournalEntriesView);
    }

    get UserCanAccessMaintenance(): boolean {
        if (this.ModuleSecurityAccess != null) {
            return this.userCanViewMaintenance() || this.userCanUpdateMaintenance();
        }
        return false;
    }

    // Check if ModuleSecurityAccess contains categories starting with "Maintenance" and ending with "view"
    userCanViewMaintenance(): boolean {
        if (this.ModuleSecurityAccess != null) {
            return this.ModuleSecurityAccess.some(
                (m) =>
                    m.category != null &&
                    m.name != null &&
                    m.category.toLowerCase().startsWith("maintenance") &&
                    m.name.toLowerCase().endsWith("view")
            );
        }
        return false;
    }
        //method to toggle collapse state
    toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
            // Emit event to notify parent component of sidebar width change
            this.$emit('sidebar-collapsed', {
                isCollapsed: this.isCollapsed,
                width: this.isCollapsed ? 60 : 156
            });
        }

    // Check if ModuleSecurityAccess contains categories starting with "Maintenance" and ending with "update"
    userCanUpdateMaintenance(): boolean {
        if (this.ModuleSecurityAccess != null) {
            return this.ModuleSecurityAccess.some(
                (m) =>
                    m.category != null &&
                    m.name != null &&
                    m.category.toLowerCase().startsWith("maintenance") &&
                    m.name.toLowerCase().endsWith("update")
            );
        }
        return false;
    }

    get UserCanAccessAudit(): boolean {
        // For now, we'll allow access to Audit if user has general access to the system
        // This can be refined later with specific audit module permissions
        const hasAccess = this.ModuleSecurityAccess != null;
        console.log("Checking Audit access:", {
            moduleSecurityAccess: this.ModuleSecurityAccess,
            hasAccess: hasAccess,
        });
        return hasAccess;
    }

    get UserCanAccessLogs(): boolean {
        return this.ModuleSecurityAccess != null;
    }

    get UserCanAccessAbout(): api.ExtendedUserData {
        return this.$store.state.security.UserData;
    }

    get UserCanAccessMatching(): boolean {
        return this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.MatchingView);
    }

    // eslint-disable-next-line complexity
    get getDefaultConfigureRoute() {
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.ConfigurationDataSourcesConnectionsManage)
        ) {
            return RouteNames.DataConnectionStringsRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.ConfigurationStagingTablesManage)
        ) {
            return RouteNames.DataStagingTableRoute;
        }
        if (this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.DataImportsMappingsView)) {
            return RouteNames.DataMapsRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.HomepagesHomepageManagementManage)
        ) {
            return RouteNames.DataHomepagesRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.DataImportsDataImportDefinitionsManage)
        ) {
            return RouteNames.DataModelMappingsRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.ConfigurationJournalEntriesManageSettings)
        ) {
            return RouteNames.DataJournalsRoute;
        }
        return RouteNames.DashboardRoute;
    }

    get getDefaultModelsRoute() {
        if (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsCreateUpdate) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsView) ||
                this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelsDelete))
        ) {
            return RouteNames.ModelViewRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelManagementManage)
        ) {
            return RouteNames.DimensionViewRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.MetadataManagementModelViewsManage)
        ) {
            return RouteNames.ModelViewsViewRoute;
        }
        return RouteNames.DashboardRoute;
    }

    get getDefaultSecurityRoute() {
        if (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementCreate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementUpdate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityUserManagementDelete))
        ) {
            return RouteNames.SecurityManagementUsersRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            (this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementCreate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementUpdate) ||
                this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementDelete))
        ) {
            return RouteNames.SecurityManagementRolesRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementAssignAuthorization)
        ) {
            return RouteNames.SecurityManagementModulesRoute;
        }
        if (
            this.ModuleSecurityAccess != null &&
            this.ModuleIdInAccess(api.ModuleAccess.SecurityRoleManagementUserReports)
        ) {
            return RouteNames.SecurityManagementUserReportsRoute;
        }
        return RouteNames.DashboardRoute;
    }

    get getDefaultLogsRoute() {
        if (this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.LogsEtlLogsView)) {
            return RouteNames.LogManagementEtlLogsRoute;
        }
        if (this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.LogsMetadataAuditLogView)) {
            return RouteNames.LogManagementAuditTrailRoute;
        }
        if (this.ModuleSecurityAccess != null) {
            return RouteNames.NotificationRoute;
        }
        return RouteNames.DashboardRoute;
    }

    get getDefaultAboutRoute() {
        return RouteNames.AboutSystemInformationRoute;
    }

    getDefaultWorkflowRoute() {
        return RouteNames.WorkflowContributorRoute;
    }

    getDefaultJournalEntriesRoute() {
        if (this.ModuleSecurityAccess != null && this.ModuleIdInAccess(api.ModuleAccess.JournalEntriesView)) {
            return RouteNames.JournalsRoute;
        }
    }

    getDefaultMaintenanceRoute() {
        if (this.UserCanAccessMaintenance) {
            return RouteNames.MaintenanceRoute;
        }
        //return RouteNames.MaintenanceRoute;
    }

    private ShowWindowsContextMenu: MouseEvent | null = null;
    Open(tab: WindowsTabData) {
        tab.BringToFront();
        this.ShowWindowsContextMenu = null;
    }

    OpenChatPopup() {
        const tab = new ChatWindowsTabData("Chat");
        this.Tabs!.push(tab);
    }

    setShowWindowsContextMenu(e: MouseEvent) {
        this.ShowWindowsContextMenu = e;
    }
}
</script>

<style scoped>
.size-sm {
    width: 16px;
    height: 16px;
}

#sidebar {
    width: 156px;
    background-color: var(--sidebar-background);
    font-size: 14px;
    line-height: 17px;
    position: absolute;
    left: 0;
    top: 86px;
    bottom: 0;
    border-right: 1px solid var(--thin-border);
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    overflow: hidden;
}

.sidebar-footer {
    margin-top: auto;
    border-top: 1px solid var(--row-hover);
}

#sidebar.collapsed {
    width: 50px;
    transition: width 0.3s ease; /* Add transition to collapsed state too */
}

.collapse-button:hover {
    background-color: var(--sidebar-btn-hover);
}

.collapse-button:active {
    background-color: var(--sidebar-btn-active);
}

.collapse-icon {
    height: 16px;
    width: 16px;
}

/* Collapsed footer button */
#sidebar.collapsed .collapse-button {
    justify-content: center;
    padding: 12px 8px;
    gap: 0;
}

.collapse-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    gap: 10px;
    text-align: center;
}

#sidebar .app-router-link {
    text-decoration: none;
    color: var(--sidebar-svg);
    width: 100%;
}

.sidebar-button {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 12px;
    text-align: center;
    word-break: break-all;
    gap: 10px;
    align-items: center;
    white-space: nowrap; /* Prevent text wrapping */
}
.sidebar-button:hover {
    background-color: var(--sidebar-btn-hover);
}

.end-user-category > :last-child .sidebar-button,
.configuration-category > :last-child .sidebar-button,
.system-category > :last-child .sidebar-button {
    border-bottom: 1px solid var(--row-hover);
}

#sidebar > :last-child .sidebar-button, 
#sidebar > :nth-last-child(2) .sidebar-button,
.sidebar-footer{
    border-bottom: none;
}

.sidebar-button .counter {
    background-color: var(--accent-color);
    color: var(--accent-foreground);
    width: 18px;
    height: 18px;
    border-radius: 10px;
}

.sidebar-button img,
.sidebar-button svg {
    filter: var(--sidebar-svg);
}

.router-link-active .sidebar-button {
    background-color: var(--sidebar-btn-active);
    font-weight: 600;
}
</style>
